module.exports = __webpack_public_path__ + "static/depoimento15-61fee4c4f6cc3d45df869ea1cebd7eaa.png";